import consumer from "./consumer";

consumer.subscriptions.create("NotificationChannel", {
  connected() {},

  disconnected() {},

  received(data) {
    const notifications = document.getElementById("notifications");

    if (!notifications) {
      console.error(
        "Notifications container not found! Make sure element with id='notifications' exists"
      );
      return;
    }

    if (data && typeof data.html === "string") {
      notifications.insertAdjacentHTML("beforeend", data.html);
      return;
    }

    console.error(
      "Received notification data is missing 'html' property or is not a string."
    );
  },
});
